module.exports = __webpack_public_path__ + "static/photo-7-0019ff379872ecbe3a7785934347d218.jpg";